import { getDefaultAuthState, AuthState } from '@/src/features/app/store/auth/state';
import { useCallback, useMemo, useState } from 'react';
import { MeDto, meRequest } from '@/src/features/api/authentication/me';
import { ENV } from '@/src/.env';

export interface AuthStore {
  state: AuthState;
  init(): Promise<void>;
  logout(): void;
}

export const useAuthStore = (): AuthStore => {
  const [state, setState] = useState(getDefaultAuthState());

  const redirectToLogin = useCallback(() => {
    const redirect = encodeURIComponent(window.location.href);
    window.location.href = `${ENV.IDENTITY_URL}/login?redirect=${redirect}`;
  }, []);

  const init = useCallback(async () => {
    const user: MeDto | undefined = await meRequest()
      .catch(() => undefined);

    if (!user) {
      redirectToLogin();
      return;
    }

    setState(prevState => ({
      ...prevState,
      user,
      initialized: true,
    }));
  }, [redirectToLogin]);

  const logout = useCallback(() => {
    redirectToLogin();
  }, [redirectToLogin]);

  return useMemo(() => ({
    state,
    init,
    logout,
  }), [state, init, logout]);
};
